import { SaleFormInput } from '@src/core/buyerApiClient';
import { formInputGroupKey } from '@src/domains/orders/core/form-inputs/formInputGroupKey';

/**
 * The 422 comes back indexed by input hash, but what gets flagged on screen is the
 * tariff row: the field itself only exists again once the modal is reopened.
 */
export const formInputGroupsWithErrors = (
  formInputGroups: Array<SaleFormInput[]>,
  errors: Record<string, string[]>,
): Set<string> => {
  const withErrors = new Set<string>();

  formInputGroups.forEach((inputs) => {
    const hasError = inputs.some((input) => (errors[input.hash]?.length ?? 0) > 0);

    if (hasError) {
      withErrors.add(formInputGroupKey(inputs));
    }
  });

  return withErrors;
};
